module.exports = {"title":"Videos","popover":"Hier kannst du Videos raufladen, die deine Guardians herunterladen können.","addVideoButton":"Video hinzufügen +","meta":"Videos"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/videos.json
// module id = wPfU
// module chunks = 1